import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCard";
import Particle from "../components/Particle";
import chotuBazaar from "../assets/projects/ChotuBazaar.png";
import fastDeal from "../assets/projects/FastDeal.png";
import upStore from "../assets/projects/UpStore.png";
import GojoShop from "../assets/projects/GojoShop.png";

const Projects = () => {
  return (
    <Container fluid id="projects" className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent Top <strong className="yellow">Projects</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={upStore}
              isBlog={false}
              title="UpStore (Clone of IndiaMart)"
              description="Upstore is an e-commerce website that specializes in clothing. Users can sign up and browse through a variety of products, add them to their cart, and proceed to checkout. Payment and shipping information can be provided at checkout, and once the payment is processed, users will be redirected to the homepage."
              techStack="Tech Stack : HTML | CSS | JavaScript"
              ghLink="https://github.com/Prabhat-kumar-11/India-Mart-clone"
              demoLink="https://inspiring-piroshki-1c6dbc.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={GojoShop}
              isBlog={false}
              title="GojoShop (Clone of Lyst)"
              description="Gojo Shop is a trendy online clothing retailer for men and women, featuring a diverse selection of stylish clothing and accessories that are always up-to-date with the latest fashion trends."
              techStack="Tech Stack : HTML | CSS | JavaScript"
              ghLink="https://github.com/Prabhat-kumar-11/Gojo-Shop"
              demoLink="https://tourmaline-arithmetic-95d669.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fastDeal}
              isBlog={false}
              title="FastDeal (Clone of SnapDeal)"
              description="It is a global luxury fashion online marketplace that connects customers with a curated selection of products from a network of independent luxury boutiques and designer brands."
              techStack="Tech Stack : React | JavaScript | ChakraUI"
              ghLink="https://github.com/Prabhat-kumar-11/Snap-Deal-Clone"
              demoLink="https://fastdeal1.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chotuBazaar}
              isBlog={false}
              title="ChotuBazaar"
              description="ChotuBazaar is an e-commerce website that specializes in offering a variety of products. The website allows users to sign up, browse through products, filter them, add them to their cart, proceed to checkout, and once the checkout is processed, users will be redirected to the homepage."
              techStack="Tech Stack : React | JavaScript | ChakraUI"
              ghLink="https://github.com/Prabhat-kumar-11/Chotu-Bazaar"
              demoLink="https://chotubazaar.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Projects;
